import type { UseFormRegisterReturn } from 'react-hook-form';

import { InputElement } from './styles';

type Props = {
	type?: 'text';
	id?: string;
	name?: string;
	registration: UseFormRegisterReturn;
	placeholder?: string;
	width?: number;
	disabled?: boolean;
	isError?: boolean;
	preventEnter?: boolean;
	autoFocus?: boolean;
	onBlur?: () => void;
};

export const Input = ({
	type = 'text',
	id,
	registration,
	placeholder,
	width,
	disabled,
	isError,
	preventEnter,
	autoFocus,
	onBlur,
}: Props) => {
	const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
		e.key === 'Enter' && e.preventDefault();
	};

	return (
		<InputElement
			id={id}
			{...registration}
			type={type}
			placeholder={placeholder}
			width={width}
			disabled={disabled}
			isError={isError}
			autoFocus={autoFocus}
			onBlur={onBlur}
			onKeyDown={preventEnter ? handleKeyDown : undefined}
		/>
	);
};
